<template>
    <ModalContainer :visible="visible" :show-footer="false" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close" @click="$emit('close-booking-client-modal')"><i class="las la-times"></i></button>
            <h4 class="modal-title">{{ $t('common.book') }}</h4>
        </template>
        <template v-slot:body>
            <div class="panel panel-default" v-show="step < 4">
                <div class="panel-body" style="padding:20px;">
                    <h1 class="h2 margin-bottom-20">1. {{$t('components.booking_client_modal.step1')}}</h1>
                    <div class="row">
                        <div class="col-xs-12 col-sm-8">
                            <p class="text-muted margin-bottom-20" v-if="appointmentSetDetail.appointments.length > 0">{{$t('components.appointment.title', {rate_name: appointmentSetDetail.rate.name, chaired_admin_name: appointmentSetDetail.appointments[0].chaired_admin_name, company_name: appointmentSetDetail.rate.company_name })}}</p>
                            <span v-if="appointmentSetDetail.is_online" class="badge">{{ $t('common.online')}}</span>  <span v-else-if="appointmentSetDetail.rate.location" class="badge">{{appointmentSetDetail.rate.location}}</span> <span v-else class="badge">{{ $t('common.in_studio')}}</span> <span class="badge">{{getStringRateType(appointmentSetDetail.rate.type)}}</span> <span class="badge">{{appointmentSetDetail.rate.duration_in_minutes}} {{$t('unit.minute_tiny')}}</span>
                        </div>
                        <div v-if="appointmentSetDetail.appointments.length === 1" class="col-xs-12 col-sm-4">
                            <div class="time-box">
                                <p style="font-size:20px;padding-top:8px;">{{getHourStringFromISO(appointmentSetDetail.appointments[0].date)}}</p>
                                {{getDateCalendarCell(appointmentSetDetail.appointments[0].date)}}
                            </div>
                        </div>
                        <div v-else-if="appointmentSetDetail.appointments.length > 1" class="col-xs-12 col-sm-4">
                            <div class="time-box">
                                <p style="font-size:15px;margin-bottom:5px;font-weight: bold">{{ $t('common.start') }}</p>
                                {{getDateCalendarCell(appointmentSetDetail.appointments[0].date)}} {{getHourStringFromISO(appointmentSetDetail.appointments[0].date)}}
                                <p style="font-size:15px;margin-top:15px;margin-bottom:5px;font-weight: bold">{{ $t('common.end') }}</p>
                                {{getDateCalendarCell(appointmentSetDetail.appointments[0].date)}} {{getHourStringFromISO(appointmentSetDetail.appointments[0].date)}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel panel-default" v-show="step < 4">
                <div class="panel-body" style="padding:20px;">
                    <h1 class="h2 margin-bottom-20">2. {{$t('components.booking_client_modal.step2')}}</h1>
                    <div class="form-horizontal">
                        <div
                            v-show="errorMessage"
                            class="alert alert-danger"
                            style="margin:10px;"
                            role="alert"
                        >
                            {{ errorMessage }}
                        </div>
                        <div class="form-group">
                            <label for="client_email" class="col-xs-12 col-md-4 control-label">{{ $t('common.email') }}</label>
                            <div class="col-xs-12 col-md-8">
                                <input class="form-control" type="text" :disabled="clientExist || creditCardCheckout" id="client_email" v-model="newReservation.clientDetail.email" placeholder="">
                            </div>
                        </div>
                        <div v-if="clientChecked" class="form-group">
                            <label for="client_firstname" class="col-xs-12 col-md-4 control-label">{{ $t('common.first_name') }}</label>
                            <div class="col-xs-12 col-md-8">
                                <input class="form-control" type="text" :disabled="clientExist || creditCardCheckout" id="client_firstname" v-model="newReservation.clientDetail.first_name" placeholder="">
                            </div>
                        </div>
                        <div v-if="clientChecked" class="form-group">
                            <label for="client_lastname" class="col-xs-12 col-md-4 control-label">{{ $t('common.last_name') }}</label>
                            <div class="col-xs-12 col-md-8">
                                <input class="form-control" type="text" :disabled="clientExist || creditCardCheckout" id="client_lastname" v-model="newReservation.clientDetail.last_name" placeholder="">
                            </div>
                        </div>

                        <div v-if="clientChecked" class="form-group">
                            <label for="client_phone" class="col-xs-12 col-md-4 control-label">{{ $t('common.phone') }}</label>
                            <div class="col-xs-12 col-md-8">
                                <VuePhoneNumberInput
                                        :disabled="clientExist || creditCardCheckout"
                                        @update="updatePhoneNumber"
                                        no-validator-state
                                        :default-country-code="country_phone"
                                        v-model="newReservation.clientDetail.phone_number"
                                        :translations="translations"
                                        id="client_phone"></VuePhoneNumberInput>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-footer" v-if="!clientChecked">
                    <a class="btn btn-primary btn-block btn-lg" @click="checkClientExist">
                        {{ $t('common.next')}} <i class="las la-angle-right"></i>
                    </a>
                </div>
            </div>
            <div class="panel panel-default" v-show="step === 3">
                <div class="panel-body" style="padding:20px;">
                    <h1 class="h2 margin-bottom-20">3. {{$t('components.booking_client_modal.step3')}}</h1>
                    <p class="margin-bottom-20">{{$t('components.booking_client_modal.select_pm')}}</p>
                    <div
                        v-show="creditCardErrorMessage"
                        class="alert alert-danger"
                        style="margin:10px;"
                        role="alert"
                    >
                        {{ creditCardErrorMessage }}
                    </div>
                    <div  class="form-horizontal">
                        <div class="form-group">
                            <label for="payment-method-options" class="col-xs-12 col-md-4 control-label">{{ $t('common.payment_method')}}</label>
                            <div class="col-xs-12 col-md-8">
                                <select class="form-control" id="payment-method-options" :disabled="creditCardCheckout"  v-model="newReservation.payment_mode">
                                    <option v-if="clientValidSubscriptions.length > 0" :value="subscriptionPaymentMode">{{$t('components.reservation.use_subscription')}}</option>
                                    <option :value="creditCardPaymentMode">{{creditCardPaymentModeName}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group" v-if="clientValidSubscriptions.length > 0 && newReservation.payment_mode === subscriptionPaymentMode">
                            <label for="subscription-options" class="col-xs-12 col-md-4 control-label">{{ $t('components.reservation.which_subscription') }}</label>
                            <div class="col-xs-12 col-md-8">
                                <select class="form-control" id="subscription-options" name="subscription-options" v-model="newReservation.paid_by_subscription">
                                    <option v-for="subscription in clientValidSubscriptions" v-bind:key="subscription.id" :value="subscription.id">
                                        {{subscription.type.name}} - {{subscription.fingerprint}}
                                        <div v-if="subscription.type.unlimited_redeemable">
                                            ({{ $t('components.subscription_type.appointment_unlimited') }})
                                        </div>
                                        <div v-else>
                                            ({{subscription.residual_redeemable_appointments}} {{ $t('components.subscription.residual_appointments') }})
                                        </div>
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group" v-if="newReservation.payment_mode === creditCardPaymentMode">
                            <div class="col-xs-12 col-md-4 control-label"></div>
                            <div class="col-xs-12 col-md-8">
                                <PriceTable v-if="appointmentSetDetail.price && appointmentSetDetail.price_currency" :price="appointmentSetDetail.price" :currency="appointmentSetDetail.price_currency"></PriceTable>
                            </div>
                        </div>
                        <div class="form-group" v-if="newReservation.payment_mode === creditCardPaymentMode && creditCardCheckout">
                            <label for="client_phone_payment" class="col-xs-12 col-md-4 control-label">{{ $t('common.credit_card') }}</label>
                            <div class="col-xs-12 col-md-8">
                                <StripeElements  ref="elementsRef"
                                                 id="client_phone_payment"
                                                 :pk=STRIPE_PUBLIC_KEY
                                                 :locale="$i18n.locale"
                                                 @token="tokenCreated"></StripeElements>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-4"></div>
                            <div class="col-xs-12 col-md-8">
                                <ConversionNote  v-if="creditCardCheckout" :price="appointmentSetDetail.price" :currency="appointmentSetDetail.price_currency"></ConversionNote>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="panel-footer">
                    <a v-if="newReservation.payment_mode === subscriptionPaymentMode || creditCardCheckout" class="btn btn-primary btn-block btn-lg" href="" @click.prevent.stop="confirmPayClick">
                        {{ $t('common.pay_and_confirm') }} <i class="las la-angle-right"></i>
                    </a>
                    <a v-else class="btn btn-primary btn-block btn-lg" href="" @click.prevent.stop="confirmCreditCardMethod">
                        {{ $t('common.next') }}<i class="las la-angle-right"></i>
                    </a>
                </div>
            </div>
            <div class="panel panel-default margin-0" v-show="step >= 4">
                <div class="panel-body" style="padding:20px;">
                    <h1 class="h2 margin-bottom-20">4. {{$t('components.booking_client_modal.step4')}}</h1>
                    <p class="margin-0 text-center" style="font-size:80px;color:#3c763d;">
                        <i class="las la-check-circle"></i>
                    </p>
                    <div class="alert alert-success margin-0" role="alert">
                        <p><b>{{$t('components.booking_client_modal.success1')}}</b> {{$t('components.booking_client_modal.success2')}}</p>
                        <p>{{$t('components.booking_client_modal.success3')}}</p>
                    </div>
                </div>
                <div class="panel-footer">
                    <a class="btn btn-primary btn-block btn-lg" href="" @click.prevent.stop="$emit('close-booking-client-modal')">
                        {{ $t('common.close') }}<i class="las la-angle-right"></i>
                    </a>
                </div>
            </div>
        </template>
    </ModalContainer>
</template>

<script>
    import parsePhoneNumber from 'libphonenumber-js'
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'
    import { StripeElements } from 'vue-stripe-checkout';
    import {Utils} from "../../common/utils";
    import i18n from "../../i18n";
    import {
        createReservationClientPublic,
        getClientAppointmentSetDetail,
        getClientCompanyByEmail,
        getCompanyClientValidSubscriptionForAppointmentSet
    } from "../../api";
    import {PAYMENT_MODE, PAYMENT_MODE_SUBSCRIPTION, STRIPE_PUBLIC_KEY} from "../../common/constants";
    import ModalContainer from "./ModalContainer";
    import PriceTable from "../common/PriceTable";
    import ConversionNote from "../common/ConversionNote";
    export default {
        name: "BookingClientModal",
        components: {ModalContainer, StripeElements, VuePhoneNumberInput, PriceTable, ConversionNote},
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            appointmentSetId: {
                type: Number,
                required: true
            },
            country: {
                type: String
            }
        },
        data: () => {
            return {
                STRIPE_PUBLIC_KEY: STRIPE_PUBLIC_KEY,
                creditCardErrorMessage: "",
                step: 1,
                loading: false,
                client_secret: "",
                errorMessage: "",
                clientExist: false,
                clientChecked: false,
                creditCardCheckout: false,
                appointmentSetDetail: {
                    rate: {},
                    appointments: []
                },
                price: "0.00",
                price_currency: "",
                clientValidSubscriptions: [],
                newReservation: {
                    clientDetail: {
                        first_name: "",
                        last_name: "",
                        email: "",
                        phone_number: "",
                        phone_number_international: ""
                    },
                    client: null,
                    rate: null,
                    appointment_set: null,
                    paid_by_subscription: null,
                    payment_mode: PAYMENT_MODE.CREDIT_CARD
                },
                clientCountry: null,
                translations: {}
            }
        },
        computed: {
            country_phone() {
                if (this.clientCountry) {
                    return this.clientCountry
                }
                return this.country;
            },
            subscriptionPaymentMode(){
                return PAYMENT_MODE_SUBSCRIPTION
            },
            creditCardPaymentMode(){
                return PAYMENT_MODE.CREDIT_CARD
            },
            creditCardPaymentModeName(){
                return Utils.getStringPaymentMode(PAYMENT_MODE.CREDIT_CARD)
            }
        },
        methods: {
            getGrossPriceOnlineWithCreditCard(price) {
                return Utils.getGrossPriceOnlineWithCreditCard(price)
            },
            async tokenCreated (token) {
                this.loading = true;
                let stripe = window.Stripe(STRIPE_PUBLIC_KEY);

                this.token = token;
                const result = await stripe.confirmCardPayment(this.client_secret, {
                    payment_method: {
                        card: {
                            token: token.id
                        },
                    }
                });


                if (result.error) {
                    if (result.error.type === "card_error") {
                        this.creditCardErrorMessage = result.error.message
                    }
                } else {

                    if (result.paymentIntent.status === "succeeded") {
                        this.step = 4
                    }

                }

                this.loading = false;
            },
            getStringRateType(type) {
                return Utils.getStringRateType(type)
            },
            getLongDateFromISO(date) {
                return Utils.getLongDateFromISO(date)
            },
            getHourStringFromISO(date) {
                return Utils.getHourStringFromISO(date)
            },
            getDateCalendarCell(date) {
                return Utils.getDateCalendarCell(date)
            },
            checkClientExist() {
                if (!this.emailFieldIsValid()) {
                    return
                }
                this.getClientCompanyByEmail(this.newReservation.clientDetail.email)
            },
            async getClientCompanyByEmail(email) {
                this.clientCountry = null;
                this.clientChecked = true;
                this.loading = true;
                try {
                    let response = await getClientCompanyByEmail(this.$route.params.company_username,
                        email);
                    this.clientValidSubscriptions = await getCompanyClientValidSubscriptionForAppointmentSet(this.$route.params.company_username, email, this.appointmentSetDetail.id);
                    const phoneNumber = parsePhoneNumber(response.phone_number);
                    this.clientCountry = phoneNumber.country;

                    this.newReservation.clientDetail = response;

                    this.loading = false;
                    this.step = 3;
                    this.clientExist = true;

                } catch (e) {
                    this.step = 3;
                    console.log(e);
                    this.loading = false;
                }
            },
            emailFieldIsValid() {
                this.errorMessage = ""
                let regex = /\S+@\S+\.\S+/;

                if (!this.newReservation.clientDetail.email || !regex.test(this.newReservation.clientDetail.email)) {
                    this.errorMessage = i18n.t('error.email_not_valid');
                    return false
                }
                return true
            },
            fieldsIsValid() {
                this.errorMessage = ""
                if (!this.emailFieldIsValid()) {
                    return false
                }
                if (!this.newReservation.clientDetail.first_name) {
                    this.errorMessage = i18n.t('error.first_name_not_valid');
                    return false
                }

                if (!this.newReservation.clientDetail.last_name) {
                    this.errorMessage = i18n.t('error.last_name_not_valid');
                    return false
                }

                if (!this.newReservation.clientDetail.phone_number_international) {
                    this.errorMessage = i18n.t('error.phone_not_valid');
                    return false
                }

                return true
            },
            async confirmCreditCardMethod() {
                if (!this.fieldsIsValid()) {
                    return false
                }

                this.loading = true;

                try {
                    let response = await createReservationClientPublic(
                        this.$route.params.company_username,
                        this.appointmentSetId,
                        this.newReservation.clientDetail.email,
                        this.newReservation.clientDetail.first_name,
                        this.newReservation.clientDetail.last_name,
                        this.newReservation.clientDetail.phone_number_international,
                        this.newReservation.paid_by_subscription,
                        this.newReservation.payment_mode,
                        i18n.locale);
                    this.loading = false;
                    this.client_secret = response.payment_client_secret;
                    this.price = response.price_amount;
                    this.price_currency = response.price_currency;
                    this.creditCardCheckout = true;
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                }
            },
            async confirmPayClick(){
                if (this.newReservation.payment_mode === PAYMENT_MODE_SUBSCRIPTION) {
                    this.loading = true;
                    try {
                        await createReservationClientPublic(
                            this.$route.params.company_username,
                            this.appointmentSetId,
                            this.newReservation.clientDetail.email,
                            this.newReservation.clientDetail.first_name,
                            this.newReservation.clientDetail.last_name,
                            this.newReservation.clientDetail.phone_number_international,
                            this.newReservation.paid_by_subscription,
                            this.newReservation.payment_mode,
                            i18n.locale);
                        this.loading = false;
                        this.step = 4

                    } catch (e) {
                        console.log(e);
                        this.loading = false;
                    }
                } else if (this.newReservation.payment_mode === PAYMENT_MODE.CREDIT_CARD) {
                    this.$refs.elementsRef.submit()
                }
            },
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            },
            updatePhoneNumber(result) {
                this.newReservation.clientDetail.phone_number_international = result.formatInternational;
            }

        },
        watch: {
            async visible(newVal) {
                if (newVal) {
                    this.loading = true;
                    try {
                        this.appointmentSetDetail = await getClientAppointmentSetDetail(this.$route.params.company_username,
                            this.appointmentSetId);
                        this.loading = false;
                    } catch (e) {
                        console.log(e);
                        this.loading = false;
                    }
                    this.translations = Utils.getTranslationsPhoneField();
                }

            },
            'newReservation.payment_mode'(newVal) {
                if (newVal !== PAYMENT_MODE_SUBSCRIPTION) {
                    this.newReservation.paid_by_subscription = null
                } else {
                    if (this.clientValidSubscriptions.length > 0) {
                        this.newReservation.paid_by_subscription = this.clientValidSubscriptions[0].id
                    }
                }
            },
            clientValidSubscriptions(newVal) {
                if (newVal.length > 0) {
                    this.newReservation.payment_mode = PAYMENT_MODE_SUBSCRIPTION;
                    this.newReservation.paid_by_subscription = newVal[0].id
                } else {
                    this.newReservation.payment_mode = PAYMENT_MODE.CREDIT_CARD;
                    this.newReservation.paid_by_subscription = null;
                }
            }
        }
    }
</script>

<style scoped>

</style>
